import { useContext, useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'contexts';

import { routes } from 'data/routes';

const useLoginForm = () => {
  const { handleSubmit, register } = useForm();

  const navigate = useNavigate();

  const { isNewPasswordSet, isNewPassword, signInWithEmail } = useContext(AuthContext);

  const [error, errorSet] = useState('');
  const [isLoading, isLoadingSet] = useState<boolean>(false);

  const onSubmit = async (data: FieldValues) => {
    try {
      isLoadingSet(true);
      await signInWithEmail(data.email, data.password);

      navigate(routes.home);
      isLoadingSet(false);
      // eslint-disable-next-line
    } catch (err: any) {
      errorSet(err.message);
      isLoadingSet(false);
    }
  };

  useEffect(() => () => isNewPasswordSet(false));

  return {
    handleSubmit,
    register,
    error,
    onSubmit,
    isNewPassword,
    isLoading,
  };
};

export { useLoginForm };
